// 
// user.js
// Use this to write your custom JS
//

import SignaturePad from "signature_pad";
import {easepick} from "@easepick/bundle";
import {LockPlugin} from "@easepick/lock-plugin";
import Chart from "chart.js";

// region add scrolled class on navbar
document.addEventListener('scroll', function (e) {
    var $nav = document.querySelector('.navbar.fixed-top');
    if (document.documentElement.scrollTop > $nav.clientHeight) {
        if (!$nav.classList.contains('scrolled')) $nav.classList.add('scrolled');
    } else {
        if ($nav.classList.contains('scrolled')) $nav.classList.remove('scrolled');
    }
});
// endregion

// region submit form
/**
 * @param parentElement
 */
function bindForms(parentElement) {
    $(parentElement).find('form:not([action])').on("submit", function (e) {
        e.stopPropagation();
        e.preventDefault();
        const form = $(this);

        const loader = form.attr("data-loader");
        let loaderElement = null;
        if (loader) {
            loaderElement = $(`
                <div class="d-flex align-items-center justify-content-center position-absolute top-0 bottom-0 left-0 right-0 bg-white" style="z-index: 3;">
                    <div class="text-center">
                        <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
                        <p class="fw-bolder">${loader}</p>
                    </div>
                </div>
            `);
            if (form.closest(".modal-content").length > 0) {
                loaderElement.appendTo(form.closest(".modal-content"));
            } else {
                form.css("position", "relative");
                loaderElement.appendTo(form);
            }
        }

        const formData = new FormData(form.get(0));
        $.ajax({
            url: window.location.pathname + window.location.search,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            success: function (response) {
                const successMessage = form.attr("data-succes-message");
                const redirect = form.attr("data-redirect");
                let successMessageLocation = form.attr("data-succes-message-location");
                if (successMessageLocation) {
                    successMessageLocation = $(successMessageLocation);
                } else {
                    successMessageLocation = form;
                }

                if (successMessage && redirect) {
                    successMessageLocation.html(`<div class="d-grid"><a href="${redirect}" class="btn btn-success">${successMessage}</a></div>`);
                    if (loaderElement) {
                        loaderElement.remove();
                    }
                } else if (successMessage) {
                    successMessageLocation.html(`<div class="alert alert-success"><h4 class="alert-heading">${successMessage}</h4></div>`);
                    if (loaderElement) {
                        loaderElement.remove();
                    }
                } else if (redirect) {
                    window.location.replace(redirect);
                } else {
                    successMessageLocation.html(`<div class="alert alert-success"><h4 class="alert-heading">Merci !</h4></div>`);
                    if (loaderElement) {
                        loaderElement.remove();
                    }
                }
            },
            error: function (error) {
                if (loaderElement) {
                    loaderElement.remove();
                }
                catchAjaxError(error);
            }
        });
    });
}

bindForms(document);
// endregion

// region bind click on .select_card
window.select_card_values = {};
document.querySelectorAll('[data-select_card_checkbox]').forEach(function (item) {
    item.addEventListener('change', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const key = item.dataset["select_card_checkbox"];

        if (event.currentTarget.checked) {
            window.select_card_values[key] = true;
        } else {
            delete window.select_card_values[key];
        }
        document.dispatchEvent(new Event("select_card_change"));
    });
});

document.querySelectorAll('.select_card').forEach(function (item) {
    item.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const checkbox = item.querySelector("[data-select_card_checkbox]");
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event("change"));
    });
});
// endregion

// region change menu image on link hover
document.querySelectorAll(".dropdown-menu-xl .dropdown-header, .dropdown-menu-xl .dropdown-item").forEach(function (item) {
    const menu = item.closest(".dropdown-menu");
    const menuImage = menu.querySelector(".dropdown-img-start");
    const menuText = menuImage.querySelector("div");
    const originMenuImage = menuImage.style.backgroundImage.slice(4, -1).replace(/"/g, "");
    const originMenuText = menuText.innerHTML;

    const itemMenuImage = item.dataset.hasOwnProperty("menu_image") ? item.dataset.menu_image : null;
    const itemMenuText = item.dataset.hasOwnProperty("menu_text") ? item.dataset.menu_text : null;

    item.addEventListener("mouseover", function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (itemMenuImage && itemMenuText) {
            menuImage.style.backgroundImage = "url(" + itemMenuImage + ")";
            menuText.innerHTML = itemMenuText;
        } else if (itemMenuImage) {
            menuImage.style.backgroundImage = "url(" + itemMenuImage + ")";
            menuText.innerHTML = "";
        } else if (itemMenuText) {
            menuImage.style.backgroundImage = null;
            menuText.innerHTML = itemMenuText;
        } else {
            if (originMenuImage) {
                menuImage.style.backgroundImage = "url(" + originMenuImage + ")";
            } else {
                menuImage.style.backgroundImage = null;
            }
            menuText.innerHTML = originMenuText;
        }
    });
});
// endregion

// region move all modal
document.querySelector("body").append(...document.querySelectorAll(".modal"));
// endregion

// region watch window.location.hash
const hashTarget = document.querySelector(`[data-bs-target="${window.location.hash}"]`);
if (hashTarget) {
    hashTarget.click();
}
// endregion

// region all events
function bindAllEvents(parentElement) {
    bindForms(parentElement);
    bindSignaturePad(parentElement);
    bindVerifyCode(parentElement);
    bindEasePick(parentElement);
    bindEditableFields(parentElement);
    bindEditableFieldChange(parentElement);
    bindFormAutomatic(parentElement);
    bindFormDelete(parentElement);
    bindContextMenu(parentElement);
    bindAjaxModal(parentElement);
    bindIframeModal(parentElement);
    bindCharts(parentElement);
}
// endregion

// region signature_pad
function bindSignaturePad(parentElement) {
    parentElement.querySelectorAll('input[data-signature_pad]').forEach(function (input) {
        const canvas = document.querySelector("#" + input.dataset.signature_pad);
        canvas.signature_pad = new SignaturePad(canvas, {
            minWidth: 1,
            maxWidth: 2,
            onEnd: function (elem) {
                input.value = this.toDataURL();
            }
        });
    });

    parentElement.querySelectorAll('[data-signature_pad_clear]').forEach(function (button) {
        const canvas = document.querySelector("#" + button.dataset.signature_pad_clear);
        const input = document.querySelector(`input[data-signature_pad="${button.dataset.signature_pad_clear}"]`);
        button.addEventListener("click", function () {
            canvas.signature_pad.clear();
            input.value = null;
        });
    });
}

bindSignaturePad(document);
// endregion

// region easepick
function bindEasePick(parentElement) {
    parentElement.querySelectorAll('input[data-easepick]').forEach(function (input) {
        const pickOptions = {
            element: document.getElementById(input.id),
            css: [
                'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
            ],
            zIndex: 10,
            lang: "fr-FR",
            inline: true,
            plugins: [LockPlugin],
            setup(picker) {
                picker.on('select', (evt) => {
                    $('#' + input.id).change();
                })
            }
        };

        input.easepick = new easepick.create(pickOptions);
    });
}

bindEasePick(document);
// end region easepick

// region verifyCode
function bindVerifyCode(parentElement) {
    $(parentElement).find("[data-sendVerifyCodeUrl]").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        const button = $(this);
        button.attr("disabled", "disabled");

        const input = button.closest(".input-group").find("input[name]");

        const ajaxData = {
            post_action: "form",
            post_signature: $(this).attr("data-sendVerifyCodeSignature"),
            post_signature_additional_keys: ["action", "method"],
            method: "POST",
            action: $(this).attr("data-sendVerifyCodeUrl")
        };

        if (button.attr("data-sendVerifyCodeToField")) {
            ajaxData["toField"] = button.attr("data-sendVerifyCodeToField");
            ajaxData["post_signature_additional_keys"].push("toField");
        }

        input.attr("placeholder", button.attr("data-sendVerifyCodeLoadingPlaceholder"));

        $.ajax({
            url: window.location.pathname + window.location.search,
            type: 'POST',
            data: ajaxData,
            success: function (apiResponse) {
                button.removeAttr("disabled");
                input.attr("placeholder", button.attr("data-sendVerifyCodeSuccessPlaceholder"));
                input.focus();
            },
            error: function (error) {
                button.removeAttr("disabled");
                input.attr("placeholder", "");
                catchAjaxError(error);
            }
        });
    });
}

bindVerifyCode(document);
// endregion

// region editableFields
function bindEditableFields(parentElement) {

    const allowedFields = ['Select']
    const editableField = $(parentElement).find('[data-component-type="FormTableModule"]').find('tr:first-of-type [data-editable-field]')
    $(parentElement).find('[data-component-type="FormTableModule"]').find('tr:first-of-type [data-editable-field]');
    if(editableField.length === 1 && allowedFields.includes(editableField.attr('data-component-type'))) {
        $(parentElement).find('[data-editable-field] > [name]').on('change', function (e) {
            e.preventDefault();
            const elem = $(this);

            setTimeout(function () {
                elem.closest('tr').find('[data-editable-field-submit]').click();
            }, 250)
        })
    }

    $(parentElement).find('[data-editable-field-submit]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        const button = $(this);
        const line = button.closest('tr');
        const config = JSON.parse(button.attr('data-editable-field-submit'));
        const datas = {
            post_action: "form",
            post_signature: config.post_signature,
            post_signature_additional_keys: ["action", "method"],
            method: "PUT",
            action: config.url,
        };

        line.find('[name]').each(function () {
            const field = $(this);
            datas[field.attr('name')] = field.val();
        });

        button.removeClass('pulse');
        button.find('i').removeClass('fas fa-save').addClass('fas fa-spinner fa-pulse');

        $.ajax({
            url: window.location.pathname + window.location.search,
            type: 'POST',
            data: datas,
            success: function (apiResponse) {
                button.find('i').removeClass('fas fa-spinner fa-pulse').addClass('fas fa-check');
                button.css({'background-color': '#279354bf'});
                setTimeout(function () {
                    button.find('i').removeClass('fas fa-check').addClass('fas fa-save');
                    button.attr('style', '');
                }, 2000);
            },
            error: function (error) {
                button.find('i').removeClass('fas fa-spinner fa-pulse').addClass('fas fa-save');
                catchAjaxError(error);
            }
        });
    });
}

function bindEditableFieldChange(parentElement) {
    $(parentElement).find('[data-editable-field] > [name]').change(function (e) {
        $(this).closest('tr').find('[data-editable-field-submit]').addClass("pulse");
    });
}

bindEditableFields(document);
bindEditableFieldChange(document);
// endregion

// region bind editAutomatic
function bindFormAutomatic(parentElement) {
    $(parentElement).find('[data-form-automatic]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        const button = $(this);

        const callAjax = function () {
            const config = JSON.parse(button.attr('data-form-automatic'));
            const datas = {
                post_action: "form",
                post_signature: config.post_signature,
                post_signature_additional_keys: ["action", "method"],
                method: config.method,
                action: config.url,
            };

            $.ajax({
                url: window.location.pathname + window.location.search,
                type: 'POST',
                data: datas,
                success: function (apiResponse) {
                    window.location.reload();
                },
                error: function (error) {
                    catchAjaxError(error);
                }
            });
        }

        if (button.attr('data-confirm-message').length > 0) {
            const modal = $(`
                <div class="modal">
                    <div class="modal-dialog modal-dialog-centered" style="max-width: 500px!important;">
                        <div class="modal-content">
                            <div class="modal-header" style="padding: 1.5rem 2.5rem;">
                                <h3 class="modal-title text-center">${button.attr('data-confirm-message')}</h3>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div class="modal-footer justify-content-between">
                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                                    ${window.customVars.hasOwnProperty('confirmCancelButtonLabel') ? window.customVars.confirmCancelButtonLabel : 'Annuler' }
                                </button>
                                <button type="button" class="btn btn-success">
                                    ${window.customVars.hasOwnProperty('confirmSuccessButtonLabel') ? window.customVars.confirmSuccessButtonLabel : 'Confirmer' }
                                </button>
                            </div>             
                        </div>
                    </div>
                </div>
            `);

            $("body").append(modal);
            modal.modal("show");
            modal.find('.btn-success').on("click", function () {
                callAjax();
                modal.modal('hide');
            });
            modal.on("hidden.bs.modal", function () {
                modal.remove();
            });
        } else {
            callAjax();
        }

    });
}
bindFormAutomatic(document);
// endregion

// region bind form delete
function bindFormDelete(parentElement) {
    $(parentElement).find("[data-form-delete]").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        const button = $(this);

        const callAjax = function (modal) {
            const config = JSON.parse(button.attr('data-form-delete'));
            const datas = {
                post_action: "form",
                post_signature: config.post_signature,
                post_signature_additional_keys: ["action", "method"],
                method: config.method,
                action: config.url,
            };

            $.ajax({
                url: window.location.pathname + window.location.search,
                type: 'POST',
                data: datas,
                success: function (apiResponse) {
                    modal.modal('hide');
                    window.location.reload();
                },
                error: function (error) {
                    catchAjaxError(error);
                    modal.modal('hide');
                }
            });
        }

        const modal = $(`
        <div class="modal">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 500px!important;">
                <div class="modal-content">
                    <div class="modal-header" style="padding: 1.5rem 2.5rem;">
                        <h3 class="modal-title text-center">${window.customVars.hasOwnProperty('deleteElementConfirmText') ? window.customVars.deleteElementConfirmText : 'Vous allez supprimer cet élément. Voulez vous continuer ?' }</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                            ${window.customVars.hasOwnProperty('confirmCancelButtonLabel') ? window.customVars.confirmCancelButtonLabel : 'Annuler' }
                        </button>
                        <button type="button" class="btn btn-success">
                            ${window.customVars.hasOwnProperty('confirmSuccessButtonLabel') ? window.customVars.confirmSuccessButtonLabel : 'Confirmer' }
                        </button>
                    </div>             
                </div>
            </div>
        </div>
    `);

        $("body").append(modal);
        modal.modal("show");
        modal.find('.btn-success').on("click", function () {
            modal.find('.btn-success').html('<i class="fas fa-spinner fa-pulse"></i>')
            callAjax(modal);
        });
        modal.on("hidden.bs.modal", function () {
            modal.remove();
        });

    });
}
bindFormDelete(document)
// endregion

// region bind context menu
function bindContextMenu(parentElement) {
    $(parentElement).find("[data-context-menu]").on("show.bs.dropdown", function (e) {
        const dropdown = $(this);

        dropdown.find('ul.dropdown-menu').html(`<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>`)

        $.ajax({
            url: window.location.pathname + window.location.search,
            type: 'POST',
            data: JSON.parse(dropdown.attr("data-context-menu")),
            success: function (apiResponse) {
                if (apiResponse) {
                    dropdown.find('ul.dropdown-menu').html(apiResponse.items);
                    dropdown.find('.dropdown-toggle').dropdown('update');
                }

                bindAllEvents(dropdown.get(0));
            },
            error: function (error) {
                catchAjaxError(error);
            }
        });
    });
}
bindContextMenu(document);
// endregion

// region ajax modal
function bindAjaxModal(parentElement) {
    $(parentElement).find("[data-ajax-modal]").click(function () {
        const button = $(this);
        button.attr("disabled", "disabled");
        $("body").css("cursor", "progress");

        let dropdownButton = null;
        if (button.closest(".dropdown").length) {
            dropdownButton = button.closest(".dropdown").find('[data-bs-toggle="dropdown"]');
            dropdownButton.attr("disabled", "disabled");
        }

        $.ajax({
            url: window.location.pathname + window.location.search,
            type: 'POST',
            data: JSON.parse(button.attr("data-ajax-modal")),
            success: function (json) {
                button.removeAttr("disabled");
                $("body").css("cursor", "default");
                if (dropdownButton) {
                    dropdownButton.removeAttr("disabled");
                }
                if (json.hasOwnProperty("modal")) {
                    const modal = $(json.modal);
                    $("body").append(modal);
                    modal.modal("show");
                    modal.on("hidden.bs.modal", function () {
                        modal.remove();
                    });

                    bindAllEvents(modal.get(0));
                }
            },
            error: function (error) {
                button.removeAttr("disabled");
                $("body").css("cursor", "default");
                if (dropdownButton) {
                    dropdownButton.removeAttr("disabled");
                }
                catchAjaxError(error);
            }
        });
    });
}
bindAjaxModal(document);
// endregion

// region iFrame modal
function bindIframeModal(parentElement) {
    $(parentElement).find("[data-iframe-modal]").click(function () {
        const button = $(this);

        // Check user agent
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (isSafari) {
            const url = button.attr('data-iframe-modal');
            window.open(url, '_blank');
        } else {
            const modal = $(`
                <div class="modal" tabindex="-1">
                    <div class="modal-dialog modal-xl">
                        <div class="modal-content">
                            <div class="modal-header" style="padding: 1.5rem 2.5rem;">
                                <h5 class="modal-title">${button.attr('data-modal-title') ? button.attr('data-modal-title') : button.text()}</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body" style="padding: 0;">
                                <iframe src="${button.attr('data-iframe-modal')}" frameborder="0" width="100%" style="height: calc(100vh - 250px);"></iframe>
                            </div>                
                        </div>
                    </div>
                </div>
            `);

            $("body").append(modal);
            modal.modal("show");
            modal.on("hidden.bs.modal", function () {
                modal.remove();
            });
        }
    });
}
bindIframeModal(document);
// endregion

// region charts
function bindCharts(parentElement) {
    $(parentElement).find("[data-chart]").each(function () {
        const canvas = $(this);

        const chartConfig = JSON.parse(canvas.attr('data-chart'));
        new Chart(canvas.get(0), chartConfig);
    });
}
bindCharts(document);
// endregion


function catchAjaxError(error) {
    let errorMessage = 'Une erreur est survenue [ERROR_eYR7a9N]';

    let responseJson = null;
    if (error.hasOwnProperty("responseJSON")) {
        responseJson = error.responseJSON;
    }
    if (responseJson && responseJson.hasOwnProperty("error")) {
        if (responseJson.error.hasOwnProperty("message_for_view")) {
            errorMessage = responseJson.error.message_for_view;
        } else if (responseJson.error.hasOwnProperty("message")) {
            errorMessage = responseJson.error.message;
        }
    }

    alert(errorMessage);

    if (error.hasOwnProperty("status") && error.status === 401) {
        window.location.replace(`${window.location.href}${window.location.search ? "&" : "?"}logout=1`);
    }
}

function copyToClipboard(str) {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}

window.userJs = {
    'bindForms' : bindForms,
    'bindSignaturePad' : bindSignaturePad,
    'bindVerifyCode' : bindVerifyCode,
    'bindEasePick' : bindEasePick,
    'bindEditableFields' : bindEditableFields,
    'bindEditableFieldChange' : bindEditableFieldChange,
    'bindFormAutomatic' : bindFormAutomatic,
    'bindFormDelete' : bindFormDelete,
    'bindContextMenu' : bindContextMenu,
    'bindAjaxModal' : bindAjaxModal,
    'bindIframeModal' : bindIframeModal,
    'bindCharts' : bindCharts,
    'copyToClipboard' : copyToClipboard,
}

